export default "__VITE_ASSET__CRzwzVnC__"